<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3">
            <v-tabs
                v-model="tab"
                :vertical="$vuetify.breakpoint.mdAndDown"
                color="secondary"
                class="d-flex"
            >
                <v-tab
                    v-for="tab in tabs"
                    :key="tab.name['en']"
                    v-text="tab.name[lang]"
                    :to="tab.to"
                    class="
                        text-capitalize
                        d-flex
                        justify-md-center
                        px-3
                        flex-column
                    "
                   
                ></v-tab>
            </v-tabs>
        </v-sheet>

        <v-tabs-items v-model="tab" class="mt-3">
            <router-view></router-view>
        </v-tabs-items>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "Catalog",

    data() {
        return {
            tab: this.$route.path,
        };
    },

    computed: {
        lang() {
            return this.$route.params.lang;
        },

        // paymentError() {
        //     return this.$store.state.loyaltyPanel.paymentError;
        // },

        tabs() {
            let tabs =  [
                    {
                    name: { el: "Δώρα", en: "Gifts", it: "Regali" },
                    to: `/${this.lang}/loyaltyPanel/catalog/gift-catalog`,
                    }
                ]
                    if (this.getPermission('gift_categories.read')) {
                        tabs.push({
                        name: {
                            el: "Κατηγορίες",
                            en: "Categories",
                            it: "Categorie",
                        },
                        to: `/${this.lang}/loyaltyPanel/catalog/catalog-categories`,
                    })
                    }
                    
                return tabs
        },
    },
    methods: {
        ...mapActions(["getPermission"])
    },

    watch: {
        $route: {
            immediate: true,
            handler(val) {
                if (val.path === `/${this.lang}/loyaltyPanel/catalog`) {
                    this.$router.push(
                        `/${this.lang}/loyaltyPanel/catalog/gift-catalog?page=1`
                    );
                }
            },
        },
    },
};
</script>
<style lang="scss">
.theme--light.v-tabs > .v-tabs-bar {
    width: 100%;
}

.v-tabs-bar.v-item-group > * {
    width: 100%;
}

.v-slide-group__content {
    width: 100%;
}

.my-subscription {
    background-color: #2a3042;
    color: white !important;
    border-radius: 5px 5px 0px 0px;
}
</style>
